import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {
  GetUsers,
  AddSubRoles,
  AddApiPermission,
} from "../../redux/Actions/userStatusService";

function AddUserPopup({
  open,
  onClose,
  portal,
  userPermissions,
}) {
  const [userEmail, setUserEmail] = useState("");
  const [role, setRole] = useState("SUB_MANAGER");
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const dispatch = useDispatch();
  const parentRoleId= localStorage.getItem("parentId")

  const handlePermissionChange = (apiName) => {
    setSelectedPermissions((prevPermissions) => ({
      ...prevPermissions,
      [apiName]: !prevPermissions[apiName],
    }));
  };

  const handleSubmit = async () => {
    if (
      userEmail &&
      role &&
      (!userPermissions?.length ||
        Object.values(selectedPermissions).includes(true))
    ) {
     
      const payload = {
        parentRole: portal,
        email: userEmail,
        role: role,
      };

      try {
        const response = await dispatch(AddSubRoles(payload));

        if (response?.payload?.statusCode === 201) {
          
          const childId= response?.payload?.data?.userRoleId;
         
           await dispatch(GetUsers(portal));
              const permissionsArray = Object.entries(selectedPermissions)
                .filter(([, canAccess]) => canAccess)
                .map(([apiName]) => ({ apiName, canAccess: true }));


              const permissions = permissionsArray.length > 0
                ? [
                    {
                      childRoleId: childId,
                      permissions: permissionsArray,
                    },
                  ]
                : [];


              const permissionPayload = {
                parentRoleId,
                childrenPermissions: permissions.length > 0 ? permissions : [],
              };

               response= await dispatch(
                AddApiPermission({ body: permissionPayload, type: portal })
              );
              if (response?.payload?.statusCode === 201) {
                 alert("User Added Successfully")
              }  
            
          
        }
        else {
          alert("user Already Exist")
        }
      } catch (error) {
        console.error("Error adding user:", error);
      }

      onClose();
    }
  };

  const isFormValid =
    userEmail &&
    role &&
    (!userPermissions?.length ||
      Object.values(selectedPermissions).includes(true));

  return (
    <Dialog open={open} onClose={onClose} >
      <DialogTitle style={{ width: 600 }}>Add User</DialogTitle>
      <DialogContent>
        <TextField
          label="User Email"
          type="email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
          fullWidth
          margin="dense"
          required
          error={!userEmail}
          helperText={!userEmail ? "Email is required" : ""}
        />

        <FormControl fullWidth margin="dense" required>
          <InputLabel>Role</InputLabel>
          <Select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            label="Role"
          >
            <MenuItem value="ADMIN">ADMIN</MenuItem>
          </Select>
        </FormControl>

        {userPermissions?.length > 0 && (
          <FormGroup>
            <p>Select Permissions:</p>
            {userPermissions.map((permission) => (
              <FormControlLabel
                key={permission.apiName}
                control={
                  <Checkbox
                    checked={!!selectedPermissions[permission.apiName]}
                    onChange={() => handlePermissionChange(permission.apiName)}
                  />
                }
                label={permission.apiName}
              />
            ))}
          </FormGroup>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!isFormValid}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddUserPopup;
